import { DefaultLoginPage } from "./default-login-page.tsx";
import { SqeLoginPage } from "./sqe-login-page.tsx";
import { useSqeLabs } from "../../../hooks/use-sqe-labs.ts";
import styles from "./login-page.module.css";

export default function LoginPage() {
  const LoginExperience = useSqeLabs() ? SqeLoginPage : DefaultLoginPage;
  return (
    <div className={styles.page}>
      <LoginExperience />
    </div>
  );
}
